import Tag from './Tag.vue'

Tag.install = (Vue) => {
    Vue.component(Tag.name, Tag)
}

export default Tag
